module.exports = __webpack_public_path__ + "static/media/loader.a26f8cba.svg";